import type { TodoStatus } from "@acto/gql/graphql";
import Employee from "./Employee";

interface WorkflowActivityInput {
  createdAt?: string | null;
  processedStatus: TodoStatus;
  client?: { id: string; name: string; externalReference: string } | null;
  assignedEmployee?: { id: string; name: string } | null;
}

export default class WorkflowActivity {
  constructor(
    public readonly date: string,
    public readonly customerId: string,
    public readonly customerName: string,
    public readonly customerExternalReference: string,
    public readonly assignedEmployee: Employee | undefined,
    public readonly isCompleted: boolean,
  ) {}

  static fromGraphql(node: WorkflowActivityInput): WorkflowActivity {
    const customerName = node.client?.name || node.client?.externalReference || "";
    const customerExternalReference = node.client?.externalReference ?? "";

    const assignedEmployee = node.assignedEmployee
      ? new Employee(node.assignedEmployee.id, node.assignedEmployee.name)
      : undefined;

    return new WorkflowActivity(
      node.createdAt ?? "",
      node.client?.id ?? "",
      customerName,
      customerExternalReference,
      assignedEmployee,
      node.processedStatus === "COMPLETED",
    );
  }
}
